import classnames from "classnames";
import CmsContent from "component/CmsContent";
import FaqAccordion from "container/FaqAccordion";
import HideIf from "util/HideIf";
import commonSectionStyles from "resources/common-css/commonSection.module.scss";
import styles from "./contentIds.module.scss";

function ContentIdsComponent(props: any) {
  const {
    contentIds, staticContentIds, getHeadingContent, HeadingIcon, backgroundUrl = "", whiteBackground = false,
    classNames, yellowHeading = false,
  } = props;
  return (
    contentIds.map((eachContent) => {
      const { content, uiType } = eachContent?.uiDetails || {};
      const contentId = eachContent.url;
      const headingContent = getHeadingContent ? getHeadingContent(contentId) : null;

      if (staticContentIds && !(staticContentIds.includes(contentId) || contentIds.includes(contentId))) {
        return null;
      }

      if (!content) {
        return null;
      }

      return (
        <div
          key={contentId}
          className={classnames({
            [styles.each_section]: !yellowHeading,
            [styles.backgroundColor]: whiteBackground,
          }, classNames)}
        >
          <HideIf show={yellowHeading}>
            <h1 className={`${commonSectionStyles.common_section} m-t-20`}>{content?.title || headingContent?.title || ""}</h1>
          </HideIf>
          <HideIf show={!yellowHeading}>
            {HeadingIcon && (
              <div className={styles.heading_icon}>
                {headingContent?.iconClass && (
                  <div
                    className={`${headingContent.iconClass} ${styles.icon_class}`}
                    style={{ background: backgroundUrl }}
                  />
                )}

                <div
                  className={styles.subheading}
                >
                  {content?.title || headingContent?.title || ""}

                </div>
              </div>
            )}
            {!HeadingIcon && (
              <>
                {headingContent?.iconClass && (
                  <div
                    className={headingContent.iconClass}
                    style={{ background: backgroundUrl }}
                  />
                )}
                <div
                  className={styles.subheading}
                >
                  {content?.title || headingContent?.title || ""}

                </div>

              </>
            )}
          </HideIf>

          <HideIf show={uiType === "STATIC_PAGE"}>
            <CmsContent className={styles.static_page} content={content?.article} />
          </HideIf>
          <HideIf show={uiType === "FAQ"}>
            <FaqAccordion faqs={content.faqs} />
          </HideIf>
        </div>
      );
    })
  );
}
export default ContentIdsComponent;
